import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Rocket, Users, UserCheck, ShieldAlert } from 'lucide-react';

const ExpertiseSectorielle = () => {
  const cards = [
    { 
      title: "PME", 
      subtitle: "Exposition du système d’information",
      desc: "Les petites et moyennes entreprises sont aujourd’hui des cibles privilégiées car elles disposent souvent de protections limitées face aux cyberattaques.", 
      icon: Building2 
    },
    { 
      title: "Startups", 
      subtitle: "Flux de données sensibles",
      desc: "Les startups technologiques traitent souvent des données critiques (clients, produits, infrastructure cloud) sans maturité complète en cybersécurité.", 
      icon: Rocket 
    },
    { 
      title: "Entrepreneurs", 
      subtitle: "Surface numérique étendue",
      desc: "Une forte présence numérique (sites, réseaux sociaux, outils SaaS) augmente drastiquement la surface d’exposition aux attaques ciblées.", 
      icon: Users 
    },
    { 
      title: "Particuliers", 
      subtitle: "Vulnérabilité des données personnelles",
      desc: "Même les particuliers peuvent être concernés par les fuites de données, les mots de passe compromis ou l’exposition d’informations personnelles en ligne.", 
      icon: UserCheck 
    }
  ];

  return (
    <section className="w-full bg-[#F6FAFD] py-20 px-6 md:px-12 overflow-hidden border-t border-slate-100">
      <div className="max-w-[1100px] mx-auto">
        
        {/* HEADER : Direct & Informatif (Strict PDF) */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-14"
        >
          <div className="flex items-center gap-2 mb-3">
            <ShieldAlert size={14} className="text-[#3b82f6]" />
            <span className="text-[#3b82f6] text-[11px] font-black uppercase tracking-[0.25em]">
              Analyse des vulnérabilités
            </span>
          </div>
          
          <h2 className="text-[#0A1931] text-[32px] md:text-[38px] font-black leading-tight mb-5 font-inter">
            Nos services s’adressent à :
          </h2>
          
          <p className="text-[#1A3D63]/70 text-[15.5px] max-w-[650px] font-medium leading-relaxed italic">
            "Comprendre son niveau de risque est la première étape d'une protection efficace."
          </p>
        </motion.div>

        {/* GRILLE : Focus contexte d'exposition */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="group relative h-full"
              >
                <div className="relative h-full bg-white border border-slate-200 p-7 rounded-2xl flex flex-col transition-all duration-300 hover:shadow-md hover:border-blue-200">
                  
                  {/* Icône sobre et pro */}
                  <div className="w-11 h-11 bg-slate-50 rounded-lg flex items-center justify-center text-slate-500 mb-6 group-hover:bg-[#3b82f6] group-hover:text-white transition-all duration-300">
                    <Icon size={20} strokeWidth={2} />
                  </div>
                  
                  <h3 className="text-[#0A1931] text-[21px] font-black mb-1 font-inter">
                    {card.title}
                  </h3>
                  
                  <p className="text-[#3b82f6] text-[10.5px] font-black uppercase tracking-wider mb-4 opacity-80">
                    {card.subtitle}
                  </p>
                  
                  <p className="text-slate-500 text-[13.5px] leading-relaxed font-medium opacity-90">
                    {card.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSectorielle;